export const PageText = {
  _1: 'Our story',
  _2: 'At aircheckr, we believe that good air quality data can positively alter our daily decisions and actions in many domains, truly improving our health.'
};

export const Categories = {
  _1: {
    title: 'aircheckr',
    subcategories: [
      {
        key: 0,
        subtitle: 'Our conviction',
        text: 'Scientific research has shown that reducing your exposure to air pollution is effectively helping. aircheckr sets itself a goal to provide the air quality information and solutions needed to reduce exposure. aircheckr turns air quality information into something positive. People are no longer defenceless. aircheckr empowers you and your customers to actively or passively make better decisions and take actions in order to breathe better air.'
      },
      {
        key: 1,
        subtitle: 'Since 2012',
        text: 'The first seeds for aircheckr were already sawn in 2012, quickly after resulting in a living lab project in the City of Antwerp. With the support of the European Space Agency (ESA), an intensive feasibility study and a demonstration project were executed.'
      }
    ]
  },
  _2: {
    title: 'Stakeholders',
    subcategories: [
      {
        key: 0,
        subtitle: 'Nazka Mapps',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'nazka logo',
            description: 'aircheckr is a product of <a href="http://www.nazka.be/index_en.html" target="_blank">Nazka Mapps</a>. Nazka makes interactive maps and location based services. Nazka is focused on mapps that matter, adding value to society.',
            logoLinkAddress: 'http://www.nazka.be/index_en.html'
          }
        ]
      },
      {
        key: 1,
        subtitle: 'Special thanks to our partners',
        logoBanners: [
          {
            key: 0,
            logoAlt: 'esa logo',
            description: 'aircheckr was partly developed under the ARTES Applications programme and co-funded by the European Space Agency (ESA).',
            logoLinkAddress: 'https://artes-apps.esa.int'
          }
        ]
      }
    ]
  },
  _3: {
    title: 'Find out more',
    links: [
      {
        text: 'Press Kit (English)',
        linkAddress: '/press'
      },
      {
        text: 'Pers (Nederlands)',
        linkAddress: '/pers'
      },
      {
        text: 'Contact Us',
        linkAddress: '/contact'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/ourstory_page.js